import { render } from "./FormTemplate.vue?vue&type=template&id=5d64ffc4&scoped=true"
import script from "./FormTemplate.vue?vue&type=script&lang=js"
export * from "./FormTemplate.vue?vue&type=script&lang=js"

import "./FormTemplate.vue?vue&type=style&index=0&id=5d64ffc4&lang=scss&scoped=true"
import "./FormTemplate.vue?vue&type=style&index=1&id=5d64ffc4&lang=scss"

import exportComponent from "D:\\Source\\mobaxe\\mobaxe.docs.app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d64ffc4"]])

export default __exports__